<template>
  <div class="main">
    <div class="subject">
      <a-table
        :columns="columns"
        :rowKey="record => record._id"
        :dataSource="lists"
        :pagination="pagination"
        :loading="loading"
        size="small"
        @change="handleTableChange"
      >
        <template slot="title">
          <a-select
            style="width: 200px"
            :value="param.channelName"
            showSearch
            @change="headChange"
          >
            <a-select-option
              v-for="item in headSiteList"
              :key="item.channelName"
            >
              {{ item.channelName }}
            </a-select-option>
          </a-select>
        </template>
        <template slot="status" slot-scope="text, record, index">
          <a-switch
            checkedChildren="启用"
            unCheckedChildren="停用"
            :checked="record.status === 1"
            @change="
              checked => {
                changeCheck(checked, record._id, index);
              }
            "
          />
        </template>
        <template slot="url" slot-scope="text">
          <a :href="text" target="_blank">点击跳转</a>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: 'id',
    dataIndex: 'id',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '公众号名称',
    dataIndex: 'channelName',
    width: '300px',
    scopedSlots: { customRender: 'channelName' },
    align: 'center'
  },
  {
    title: '前台显示',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    width: '220px',
    align: 'center'
  },
  {
    title: '文章标题',
    dataIndex: 'title',
    scopedSlots: { customRender: 'titleIndex' },
    align: 'center'
  },
  {
    title: '发布时间',
    dataIndex: 'pubTime',
    scopedSlots: { customRender: 'pubTime' },
    align: 'center'
  },
  {
    title: '文章原链接',
    dataIndex: 'url',
    scopedSlots: { customRender: 'url' },
    align: 'center'
  }
];
export default {
  components: {},
  data() {
    return {
      loading: false,
      columns,
      lists: [],
      pagination: { pageSize: 20 },
      headSiteList: [],
      param: {
        channelName: '',
        title: '',
        limit: 20,
        page: 1
      }
    };
  },
  methods: {
    getList(param) {
      this.loading = true;
      this.$http
        .post('https://videoshow.ycrmt.cn/task/pull/wxarticle', param)
        .then(res => {
          const pagination = { ...this.pagination };
          if (res.data.state === 0) {
            this.lists = res.data.data.lists;
            pagination.total = res.data.data.total;
          } else {
            pagination.total = 0;
            this.lists = [];
          }
          this.loading = false;
          this.pagination = pagination;
        });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.param.page = this.pagination.current;
      this.getList(this.param);
    },
    headChange(value) {
      this.param.channelName = value;
      this.getList(this.param);
    },
    getChannelList() {
      this.loading = true;
      this.$http
        .post('https://videoshow.ycrmt.cn/task/pull/wxchannel', {
          page: 1,
          limit: 9999,
          wxSiteId: -1
        })
        .then(res => {
          if (res.data.state === 0) {
            this.headSiteList = res.data.data.lists;
          }
        });
    },
    changeCheck(checked, _id, index) {
      let type = 0;
      if (checked) {
        type = 1;
      } else {
        type = 0;
      }
      this.setList(_id, type, index);
    },
    setList(id, status, index) {
      this.$http
        .post('https://videoshow.ycrmt.cn/task/pull/wxarticleset', {
          _id: id,
          status
        })
        .then(res => {
          if (res.data.state === 0) {
            this.lists[index].status = status;
          }
        });
    }
  },
  created() {
    this.getList(this.param);
    this.getChannelList();
  },
  mounted() {}
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
}
.subject {
  padding: 10px;
}
</style>
